export default "__VITE_ASSET__qLBhJ$cv__"